/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Live-Chat screen tabs
export const LIVECHAT_SCREEN_TABS = {
  NEW: 'new',
  OPEN: 'open',
  CLOSED: 'closed',
  REQUESTS_HISTORY: 'requests-history',
  SETTINGS: 'settings',
  ADMIN_SETTINGS: 'admin-settings'
};

// Live-Chat participant types
export const LIVECHAT_PARTICIPANT_TYPES = {
  AGENT: 'agent',
  ENDUSER: 'end-user'
};

// Request status types
export const REQUEST_STATUSES = {
  NEW: 'new',
  ACCEPTED: 'accepted',
  MISSED: 'missed'
};

// Conversation status types
export const CONVERSATION_STATUSES = {
  STARTED: 'started',
  FINISHED: 'finished'
};

// Live-Chat message types
export const LIVECHAT_MESSAGE_TYPES = {
  TEXT: 'text',
  SYSTEM_MESSAGE: 'system_message'
};

// Live-Chat flags
export const LIVECHAT_FLAGS = {
  IMPORTANT: 'important'
};

// Live-Chat application modes
export const LIVECHAT_MODES = {
  PUBLIC: 'public',
  SEMI_PRIVATE: 'semi-private'
};

export const LIVECHAT_SEND_MESSAGE_MODE = {
  /** Send message when the user presses the 'Enter' key */
  ENTER: 'enter',
  /** Send message when the user presses the 'Send Button' or 'ctrl/cmd + enter'*/
  SEND_BUTTON: 'send_button'
};

export const LIVECHAT_EVENT_TYPES = {
  LIVECHAT_REQUEST_ACCEPTED: 'LIVECHAT_REQUEST_ACCEPTED',
  LIVECHAT_TERMINATED: 'LIVECHAT_TERMINATED',
  LIVECHAT_TRANSFERRED: 'LIVECHAT_TRANSFERRED',
  LIVECHAT_REQUEST_MISSED: 'LIVECHAT_REQUEST_MISSED',
  LIVECHAT_REQUEST_CLOSED: 'LIVECHAT_REQUEST_CLOSED',
  /** When the Subscriber is already in a active Live-chat */
  LIVECHAT_IS_IN_PROGRESS: 'LIVECHAT_IS_IN_PROGRESS',
  /** When the LiveChat Intro Node gets triggered out of Business Hours */
  LIVECHAT_OUT_OF_BUSINESS_HOURS: 'LIVECHAT_OUT_OF_BUSINESS_HOURS',
  /** When the LiveChat Intro Node gets triggered while a Pending LiveChat already exists */
  LIVECHAT_REQUEST_EXISTS: 'LIVECHAT_REQUEST_EXISTS',
  /** When a generic error occurred */
  LIVECHAT_GENERIC_ERROR: 'LIVECHAT_GENERIC_ERROR',
  /** When the LiveChat Intro Node gets triggered while LiveChat is disabled for the tenant */
  LIVECHAT_IS_DISABLED: 'LIVECHAT_IS_DISABLED'
};

// All possible incoming events from Live-Chat Manager
export const INCOMING_EVENTS = {
  AUTHORIZATION_GRANTED: 'authorization_granted',
  REQUEST_BEGIN: 'request_begin',
  REQUEST_END: 'request_end',
  REQUEST_MISSED: 'request_missed',
  REQUEST_ACCEPT_ACK: 'request_accept_ack',
  REQUEST_CREATE_ACK: 'request_create_ack',
  CONVERSATION_CREATE: 'conversation_create',
  CONVERSATION_UPDATE: 'conversation_update',
  CONVERSATION_READ_ACK: 'conversation_read_ack',
  CONVERSATION_END_ACK: 'conversation_end_ack',
  MESSAGE_SENT: 'message_sent',
  CONVERSATION_TYPING: 'conversation_typing',
  NOTIFICATION: 'notification',
  ERROR: 'error'
};

// All possible outgoing events towards Live-Chat Manager
export const OUTGOING_EVENTS = {
  REQUEST_ACCEPT: 'request_accept',
  REQUEST_CREATE: 'request_create',
  CONVERSATION_READ: 'conversation_read',
  CONVERSATION_END: 'conversation_end',
  CONVERSATION_JOIN: 'conversation_join',
  CONVERSATION_TYPING: 'conversation_typing',
  CONVERSATION_LEAVE: 'conversation_leave',
  PARTICIPANT_FLAG: 'participant_flag'
};
